import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { DuckScene } from "../components/DuckScene";
import { FullscreenViewer } from "../components/FullscreenViewer";
import { API, shareLink, shareModelUrl } from "../lib/api";
import { FrontImage } from "../components/FrontImage";

export default function EmbedPage() {
  const { id } = useParams();
  const [duck, setDuck] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/share/${id}`)
      .then((r) => setDuck(r.data))
      .catch(() => setError("This duck is not available."));
  }, [id]);

  return (
    <FullscreenViewer
      testId="embed-root"
      baseClassName="duck-canvas-wrap fixed inset-0 overflow-hidden"
      showButton={duck?.build_status === "ready"}
    >
      {duck?.build_status === "ready" ? (
        <DuckScene url={shareModelUrl(duck.id)} />
      ) : duck ? (
        <FrontImage creation={duck} alt="duck render" className="h-full w-full object-cover" />
      ) : (
        <div className="grid h-full place-items-center text-sm text-muted-foreground" data-testid="embed-status">
          {error || "Loading…"}
        </div>
      )}
      <a
        href={shareLink(id)}
        target="_blank"
        rel="noreferrer"
        data-testid="embed-badge"
        className="absolute bottom-3 right-3 flex items-center gap-1.5 rounded-full bg-background/85 backdrop-blur px-3 py-1.5 text-xs font-semibold border border-border shadow hover:bg-background"
      >
        <img src="/zdg-logo.png" alt="" className="h-5 w-auto" /> Made with Duckify<span className="text-accent">3D</span>
        <span className="text-muted-foreground font-normal">by Zero Ducks Given</span>
      </a>
    </FullscreenViewer>
  );
}
